/**
 * Wallet account type constants.
 * Must match entity.AccountType* in b3os-workflow.
 */
export const ACCOUNT_TYPE_SMART_WALLET = "smart_wallet";
export const ACCOUNT_TYPE_EOA = "eoa";
export const ACCOUNT_TYPE_POLYMARKET_DEPOSIT_WALLET = "polymarket_deposit_wallet";
